import React from 'react';
import { useObserver } from 'mobx-react-lite';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import NoSsr from '@material-ui/core/NoSsr';

import useUI from 'hooks/use-ui';
import useProductQueryParams from 'src/hooks/use-product-query-params';

import PaginationControls from 'components/core/pagination-controls';
import { WhoopsContent, WhoopsReason } from 'src/components/whoops';
import ProductItemList from './product-item-list';
import ProductCardList from './product-card-list';
import { ShopAllProductsLink } from './shop-all-products-link';
import { hasActiveProductFilters } from './product-list.utils';
import { useProductListConciergeContent } from './use-product-list-concierge-content';

export default function ProductList(props) {
  const {
    products,
    productsFilter,
    dispensary,
    totalPages = 1,
    displaySpecial,
    displayStaffPick,
    trackerSource,
    adPlacement,
    loading = false,
    productsCarouselQueries,
  } = props;
  const UI = useUI();
  const isNewProductCardBreakpoint = useMediaQuery(`(max-width: 364px)`);

  const menuLayout = useObserver(() => UI.menuLayout);
  const cardView = menuLayout === 'cards';

  const { queryParams, setQueryParams } = useProductQueryParams();
  const hasPagination = totalPages > 1;

  const isBareAllProductsPage = UI.onSearchPage && !hasActiveProductFilters(queryParams);
  const showShopAllProductsLink = !isBareAllProductsPage;

  function handlePageSelect(newPage) {
    setQueryParams({ page: newPage });
    window.scrollTo(0, 0);
  }

  const ListComponent = cardView && !isNewProductCardBreakpoint ? ProductCardList : ProductItemList;
  const { entry: conciergeEntry } = useProductListConciergeContent({
    productsFilter,
    productsCount: products?.length ?? 0,
    loading,
    dispensary,
  });

  if (!loading && !products?.length) {
    return <WhoopsContent reason={WhoopsReason.noProducts} />;
  }

  return (
    <NoSsr>
      <div>
        <ListComponent
          products={products}
          dispensary={dispensary}
          displaySpecial={displaySpecial}
          displayStaffPick={displayStaffPick}
          trackerSource={trackerSource}
          adPlacement={adPlacement}
          productsCarouselQueries={productsCarouselQueries}
          hasPagination={hasPagination}
          conciergeEntry={conciergeEntry}
        />

        {hasPagination && (
          <PaginationControlsContainer>
            <PaginationControls numPages={totalPages} currentPage={queryParams.page} onPageSelect={handlePageSelect} />
          </PaginationControlsContainer>
        )}

        {!loading && showShopAllProductsLink && <ShopAllProductsLink />}
      </div>
    </NoSsr>
  );
}

const PaginationControlsContainer = styled.div`
  margin: 56px 0;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-bottom: 0;
    margin-top: 48px;
  }
`;
